import DiscountBrowser from 'components/admin/Discounts/DiscountBrowser'
import DiscountDetails from 'components/admin/Discounts/DiscountDetails'
import CreditDetails from 'components/admin/Discounts/CreditDetails'
import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadDiscounts } from 'redux/discounts'
import { loadProducts } from 'redux/product'
import { cancelConfirm } from 'redux/navigation'
import { Grid } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import { loadCustomerOrders } from 'redux/carts'

const mapStateToProps = (state) => {
  const { discountsLoading, discounts } = state.discounts
  return { discountsLoading, discounts }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadDiscounts,
      loadCustomerOrders,
      loadProducts,
    },
    dispatch
  )
}

class DiscountsContainer extends React.Component {
  componentWillMount() {
    const { loadDiscounts, loadProducts, loadCustomerOrders } = this.props
    loadDiscounts()
    loadProducts()
    loadCustomerOrders(true)
  }

  render() {
    const {
      match: { params },
      discounts,
    } = this.props
    const currentDiscount = discounts.find(
      (discount) => discount.id === +params.discount_id
    )

    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={5}
            widescreen={5}
            className="stacked top up-to-computer">
            <DiscountBrowser />
          </Grid.Column>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={7}
            widescreen={7}>
            {!currentDiscount ||
              (!params.discount_id && <ComponentPlaceholder />)}
            {(params.discount_id === '+credit' ||
              (!!currentDiscount && currentDiscount.kind === 'credit')) && (
              <CreditDetails />
            )}
            {(params.discount_id === '+discount' ||
              (!!currentDiscount && currentDiscount.kind !== 'credit')) && (
              <DiscountDetails />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

DiscountsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscountsContainer)
export default withRouter(DiscountsContainer)



// WEBPACK FOOTER //
// ./src/containers/admin/discounts.jsx